import React from 'react';
import { ChannelConnectionProps } from './ChannelConnection';
import { Skeleton } from '@mui/material';
import useChannelAction from './hooks/useChannelAction';
import { StatusButton } from '../../Merchandiser/Components/StatusButton';
import { getIcon } from '../../../util/getIcon';
import useCommanderStatus from '../../../../../redux/commander/commander-status/hooks/useCommanderStatus';

function ChannelAction(props: ChannelConnectionProps) {
  const {
    value: actionValue,
    name: actionName,
    valueString: actionString,
    loading,
  } = useChannelAction(props);

  const { commanderStatus } = useCommanderStatus(props.channel?.deviceId || '');
  const isOn = commanderStatus?.mqttConnected && commanderStatus?.vpnConnected;

  return (
    <div>
      {loading && actionValue == undefined ? (
        <Skeleton variant="text" width={40} component={'span'} />
      ) : (
        <StatusButton
          description={`${actionName} ${actionString}`}
          icon={getIcon(props.channel?.channel ?? '')}
          onClick={props.onClick || (() => {})}
          status={actionString}
          loading={loading}
          isOn={isOn}
        />
      )}
    </div>
  );
}

export default ChannelAction;
